import { isTextNode, isElementNode } from 'anodum';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import findLastTextNode from './find-last-text-node';
import isTextNodeWithSpacingOnly from '../verifiers/is-text-node-with-spacing-only';
import findNextNode from './find-next-node';
import getAdvancedSelection from '../../text-formatting/accessors/get-advanced-selection';
import findPrevNode from './find-prev-node';
import setCaretAtTheBeginningOfNode from './set-caret-at-the-beginning-of-node';
import setCaretInTheEndOfNode from './set-caret-in-the-end-of-node';
import isReverseDirectionAfterSelectionChange from './is-reverse-direction-after-selection-change';
import getLiveElement from '../../hdrm/accessors/get-live-element';

let prevSelection = {};

const resetPrevSelection = () => {
  prevSelection = {};
};

const processImageSelection = (focusedElementId) => {
  const focusedElement = getLiveElement(focusedElementId);
  const selection = getAdvancedSelection();

  if (!selection) {
    resetPrevSelection();
    return false;
  }

  const { anchorNode, anchorOffset, focusNode, focusOffset, isCollapsed } = selection;
  if (!anchorNode || !focusNode) {
    resetPrevSelection();
    return false;
  }

  const isBackwards = selection.isBackwards();
  const startNode = isBackwards ? focusNode : anchorNode;
  const endNode = isBackwards ? anchorNode : focusNode;

  // Detecting in which direction user changed selection(by arrow keys).
  const isReverseDirection = isReverseDirectionAfterSelectionChange(prevSelection, focusedElement);

  // Store selection as previous to correct detecting direction
  prevSelection = {
    anchorNode,
    focusNode,
    anchorOffset,
    focusOffset,
  };

  const firstNode = isTextNode(startNode) ? startNode.parentElement : startNode;
  const lastNode = isTextNode(endNode) ? endNode.parentElement : endNode;

  const startImage = firstNode.closest(IMAGE_SELECTOR);
  const endImage = lastNode.closest(IMAGE_SELECTOR);
  if (!startImage && !endImage) return false;

  if (isCollapsed) {
    if (isReverseDirection) {
      const prevNode = findPrevNode(startImage);
      setCaretInTheEndOfNode(prevNode);
    } else {
      const nextNode = findNextNode(startImage);
      setCaretAtTheBeginningOfNode(nextNode);
    }
  } else {
    const imageNodes = [startImage, endImage];
    imageNodes.forEach((imageNode) => {
      if (!imageNode) return;
      if (isReverseDirection) {
        let prevNode = imageNode.previousSibling;

        while (prevNode && isTextNodeWithSpacingOnly(prevNode)) {
          prevNode = prevNode.previousSibling;
        }

        if (isElementNode(prevNode)) {
          prevNode = findLastTextNode(prevNode);
        }

        const offset = prevNode.data.length;
        selection.nativeSelection.extend(prevNode, offset);
      } else {
        selection.nativeSelection.extend(imageNode.nextSibling);
      }
    });
  }

  selection.refresh();
  return true;
};

export default processImageSelection;
